import { ComponentType, FC } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { useAuthManager } from 'redesign/components/common/contexts/AuthManager';
import { clearAuthCache, persistLastVisitedURL } from 'redesign/helpers/auth';
import AuthClient from 'services/api/auth_client';

interface WithAuthenticationProps {
    component: ComponentType;
    [componentProp: string]: any;
}

const WithAuthentication: FC<WithAuthenticationProps> = props => {
    const { component: Component, ...componentProps } = props;
    const { isAuthenticated } = useAuthManager();
    const location = useLocation();
    if (isAuthenticated()) {
        return <Component {...componentProps} />;
    }

    const { pathname, search } = location;
    const searchParams = new URLSearchParams(search);

    if (searchParams.has('redirectsso') === true) {
        searchParams.delete('redirectsso');
        persistLastVisitedURL(`${pathname}?${searchParams.toString()}`);
        window.location.href = new AuthClient().sso_redirect();
        return null;
    }
    persistLastVisitedURL(`${pathname}?${searchParams.toString()}`);
    clearAuthCache();
    return <Navigate to={{ pathname: '/login' }} replace />;
};

export default WithAuthentication;
